import { ProfileFieldType } from "@/shared/api/profilebuilder";

export const getValidationRules = (type: ProfileFieldType, obj: {[key: string]: any}) => {
    switch(type) {
    case 'string':
    case 'text':
        return {
            min_length: obj['min_length'],
            max_length: obj['max_length'],
            regexp: ''
        }    
    case 'natural_number':
    case 'integer':
        return {
            min_number: obj['min_number'],
            max_number: obj['max_number']
        } 
    case 'date':
        return {
            min_date: obj['min_date'],
            max_date: obj['max_date']  
        }
    case 'file':
        return {
            allowed_extensions: obj['allowed_extensions']
        }
    default:
        return {}
    }
}